import React, { useState, useEffect } from "react";
import { Container, TextField } from "@mui/material";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import localize from "../../../common/localize";
import useGlobalContext from "../../../hooks/useGlobalContext";
import Combobox from "../../../components/common/Combobox";
import CreatedByText from "../../../components/common/CreatedByText";

export default function AddOrEditProvider() {
  const { providerModel, setProviderModel, locations, setCity, cities } =
    useGlobalContext();

  const handleChange = (e) => {
    setProviderModel({
      ...providerModel,
      [e.target.name]: e.target.value,
    });
  };

  const handleIdentificationTypeChange = (identificationType) => {
    if (identificationType) {
      setProviderModel({
        ...providerModel,
        IdentificationType: identificationType,
      });
    }
  };

  const handleStateChange = (currentState) => {
    if (!currentState) {
      setProviderModel({
        ...providerModel,
        StateId: 0,
        State: null,
        CityId: 0,
        City: null,
      });
      return;
    }

    setProviderModel({
      ...providerModel,
      StateId: currentState.Id,
      State: currentState,
      CityId: 0,
      City: null,
    });
  };

  const handleCityChange = (currentCity) => {
    if (!currentCity) {
      setProviderModel({
        ...providerModel,
        CityId: 0,
        City: null,
      });
      return;
    }

    setProviderModel({
      ...providerModel,
      CityId: currentCity.Id,
      City: currentCity,
    });
  };

  const [states, setStates] = useState(null);
  const [citiesData, setCities] = useState(null);

  const validateStateChange = () => {
    if (providerModel?.StateId > 0) {
      const selectedState = states?.find(
        (element) => element.Id === providerModel?.StateId
      );
      if (selectedState) {
        setCity(selectedState.Code);
      }
    }
  };

  useEffect(() => {
    validateStateChange();
  }, [providerModel?.StateId, states]);

  useEffect(() => {
    if (locations.Ok && locations.Data.length > 0) {
      setStates(locations.Data);
    }
  }, [locations]);

  useEffect(() => {
    if (cities?.Ok && cities.Data.length > 0) {
      setCities(cities.Data);
    }
  }, [cities]);

  return (
    <div>
      <Container
        sx={{ paddingLeft: "0px !important;", paddingRight: "0px !important;" }}
        style={{ width: "100%" }}
      >
        <div className="w-full">
          <section className="flex justify-center content-center items-center ">
            <section id="ReportData" className="w-full">
              <div className="flex justify-between my-4">
                <Combobox
                  isRequired
                  id="IdentificationType"
                  handleValueChange={handleIdentificationTypeChange}
                  fieldValue={providerModel?.IdentificationType ?? null}
                  fieldOptions={[
                    {
                      Id: "Cédula de ciudadanía",
                      Name: "Cédula de ciudadanía",
                    },
                    { Id: "Nit", Name: "Nit" },
                    { Id: "Pasaporte", Name: "Pasaporte" },
                    {
                      Id: "Cédula de extranjería",
                      Name: "Cédula de extranjería",
                    },
                    { Id: "Otro", Name: "Otro" },
                  ]}
                  fieldLabel={localize.identification_type}
                />
                <div className="mx-2" />
                <TextField
                  required
                  InputLabelProps={getInputLabelProps()}
                  inputProps={getInputProps()}
                  size="small"
                  fullWidth
                  name="Identification"
                  value={providerModel.Identification}
                  id="Identification"
                  label={localize.identification}
                  variant="outlined"
                  onChange={handleChange}
                />
              </div>

              <TextField
                required
                InputLabelProps={getInputLabelProps()}
                inputProps={getInputProps()}
                size="small"
                fullWidth
                name="Name"
                id="Name"
                value={providerModel.Name}
                label={localize.name}
                variant="outlined"
                onChange={handleChange}
              />
              {/* States */}
              <div className="flex justify-between my-4">
                <Combobox
                  isRequired
                  id="State"
                  handleValueChange={handleStateChange}
                  fieldValue={providerModel?.State}
                  fieldOptions={states ?? []}
                  fieldLabel={localize.department}
                />

                {/* Cities */}
                <div className="mx-2" />
                <Combobox
                  isRequired
                  id="City"
                  handleValueChange={handleCityChange}
                  fieldValue={providerModel?.City}
                  fieldOptions={providerModel?.State ? citiesData ?? [] : []}
                  fieldLabel={localize.city}
                />
              </div>
              <TextField
                required
                InputLabelProps={getInputLabelProps()}
                inputProps={getInputProps()}
                size="small"
                fullWidth
                name="Address"
                id="Address"
                value={providerModel.Address}
                label={localize.address}
                variant="outlined"
                onChange={handleChange}
              />

              <div className="flex justify-between my-4">
                <TextField
                  required
                  InputLabelProps={getInputLabelProps()}
                  inputProps={getInputProps()}
                  size="small"
                  fullWidth
                  name="PhoneNumber"
                  id="PhoneNumber"
                  value={providerModel.PhoneNumber}
                  label={localize.phone_number}
                  variant="outlined"
                  onChange={handleChange}
                />
                <div className="mx-2" />
                <TextField
                  InputLabelProps={getInputLabelProps()}
                  inputProps={getInputProps()}
                  size="small"
                  fullWidth
                  name="Email"
                  id="Email"
                  value={providerModel.Email}
                  label={localize.email}
                  variant="outlined"
                  onChange={handleChange}
                />
              </div>
              <TextField
                InputLabelProps={getInputLabelProps()}
                inputProps={getInputProps()}
                size="small"
                fullWidth
                value={providerModel.ContactName}
                name="ContactName"
                id="ContactName"
                label={localize.contact_name}
                variant="outlined"
                onChange={handleChange}
              />
            </section>
          </section>
        </div>
      </Container>

      <CreatedByText entity={providerModel} />
    </div>
  );
}
